// extracted by mini-css-extract-plugin
module.exports = {"canvas":"RealtimeChart_canvas__krrOY"};